module.exports = __webpack_public_path__ + "web/img/logintext-zh.1c1a9acf.png";